module.exports = __webpack_public_path__ + "static/media/stay-relevant-logo.851212cc.svg";